/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import React from 'react'
import { Route, RouteComponentProps } from 'react-router'
import './LandingPage.scss'
import { ILandingPageStateManager, IProductCategoryInformation, IProductInformation } from '../../services/LandingPageStateManager/contracts'
import { container } from '../../configuration/ServiceLocator'
import { observer } from 'mobx-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faCaretRight } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import Card from 'react-bootstrap/Card'
import { Container, Row, Col } from 'reactstrap'
import ReactGA from 'react-ga4'
import { UserEventLogger } from '../../utils/UserEventLogger'

export interface ILandingPageProps extends RouteComponentProps<any> {
	landingPageStateManager: ILandingPageStateManager
}

export interface ILandingPageState {}

@observer
export class LandingPage extends React.Component<ILandingPageProps, ILandingPageState> {
	/**
	 *
	 */
	searchTerm: string
	constructor(props: Readonly<any>) {
		super(props)
		this.props.landingPageStateManager.getProductCategoryList().catch(error => console.error(error))
		this.searchTerm = ''

		this.onSearchEnter = this.onSearchEnter.bind(this)
		this.SearchResults = this.SearchResults.bind(this)
	}

	/**On Enter Key Press  */
	onSearchEnter(event: any) {
		if (event.key === 'Enter') {
			event.preventDefault()
			event.stopPropagation()
			this.props.history.push('./SearchResults?searchTerm=' + encodeURIComponent(this.searchTerm))
			UserEventLogger.handleUserClickEvent(event, 'SupportSite - Landing Page Search', 'Search - ' + this.searchTerm)
		}
	}

	/**On Search button click*/
	SearchResults(event: any) {
		event.preventDefault()
		// halt if validation fails
		if (this.searchTerm.trim() && this.searchTerm.trim() != '') {
			this.props.history.push('./SearchResults?searchTerm=' + encodeURIComponent(this.searchTerm))
			UserEventLogger.handleUserClickEvent(event, 'SupportSite - Landing Page Search', 'Search - ' + this.searchTerm)
		}
	}

	handleProductLinkClick(event: any) {
		UserEventLogger.handleUserClickEvent(event, 'SupportSite - Landing Page Product Link Click', '')
	}

	render() {
		return (
			<div className="container bootstrap snippets bootdey">
				<div className="row landingRow">
					<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 landingChildRow">
						<div className="well search-user">
							<div className="product-header">
								<p className="user-wish">
									<span>
										<b>{this.props.landingPageStateManager.userName}</b>
									</span>
									, how can we help you today?
								</p>
							</div>
							<div className="input-group input-group-landingPage">
								<input type="text" className="form-control landing-search-no-border" placeholder="Search Support Resources" onKeyDown={e => this.onSearchEnter(e)} onChange={e => (this.searchTerm = e.target.value)} />
								<div className="input-group-append">
									<button type="button" className="btn btn-secondary search-btn landing-search-btn-hgt" onClick={e => this.SearchResults(e)}>
										<FontAwesomeIcon icon={faSearch} />
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 product-header">
					<h4 className="staticHeader">Explore by Product</h4>
				</div>
				<div className="landingDiv">
					{
						<Container>
							<Row className="landingProductsRow">
								<Col>
									{this.props.landingPageStateManager.productCategoryList.productCategoryList
										.filter((value: any, filterIndex: number) => filterIndex % 2 === 0)
										.map((item: IProductCategoryInformation, index: number) => {
											return (
												<Card key={index}>
													<Card.Header className="list-group-item">
														<b>{item.productCategoryName}</b>
													</Card.Header>
													<Card.Body>
														{item.ProductInfos.map((productItem: IProductInformation, productIndex: number) => {
															return (
																<Card.Text className="cardProductItem" key={productIndex}>
																	<Link to={'./product/' + productItem.code + '/' + productItem.name} key={productIndex} className="list-group-item list-products" onClick={this.handleProductLinkClick}>
																		{productItem.name}{' '}
																		<span className="pull-right">
																			<FontAwesomeIcon icon={faCaretRight} />
																		</span>
																	</Link>
																</Card.Text>
															)
														})}
													</Card.Body>
												</Card>
											)
										})}
								</Col>
								{this.props.landingPageStateManager.productCategoryList.productCategoryList.length > 1 ? (
									<Col>
										{this.props.landingPageStateManager.productCategoryList.productCategoryList
											.filter((value: any, filterIndex: number) => filterIndex % 2 === 1)
											.map((item: IProductCategoryInformation, index: number) => {
												return (
													<Card key={index}>
														<Card.Header className="list-group-item">
															<b>{item.productCategoryName}</b>
														</Card.Header>
														<Card.Body>
															{item.ProductInfos.map((productItem: IProductInformation, productIndex: number) => {
																return (
																	<Card.Text className="cardProductItem" key={productIndex}>
																		<Link to={'./product/' + productItem.code + '/' + productItem.name} key={productIndex} className="list-group-item list-products" onClick={this.handleProductLinkClick}>
																			{productItem.name}{' '}
																			<span className="pull-right">
																				<FontAwesomeIcon icon={faCaretRight} />
																			</span>
																		</Link>
																	</Card.Text>
																)
															})}
														</Card.Body>
													</Card>
												)
											})}
									</Col>
								) : (
									<></>
								)}
							</Row>
						</Container>
					}
				</div>
			</div>
		)
	}
}

export const LandingPageConnected = () => {
	const store = container.get<ILandingPageStateManager>('ILandingPageStateManager')
	
	return (
		<Route 
			exact 
			path="/pages/landingpage" 
			render={props => { 
				ReactGA.send({ hitType: "pageview", page: "props.location.pathname" }); 
				return <LandingPage {...props} landingPageStateManager={store} />} } />
	)
}
